module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/id_3-ebd9ec1f2fa9f00458c2860cf1855a97.jpg";